module.exports = __webpack_public_path__ + "img/icon-phone.e2bd143e.svg";